import * as React from 'react'
import { FieldProps, Field } from 'formik'
import { ControlField } from '@espoon-voltti/react-components/elements/form'
import { fieldState, ErrorMessage, setFieldValue } from '../formik-util'
import { IntegerInput } from '../integer'
import { InputProps } from './types'

export const FormIntegerField = (p: InputProps) => (
  <Field name={p.name}>
    {({ field, form }: FieldProps) => (
      <ControlField
        required={p.required}
        dataQa={p.dataQa}
        {...field}
        label={p.label}
        state={fieldState(field.name, form)}
        message={<ErrorMessage name={field.name} />}
      >
        <IntegerInput
          id={field.name}
          name={field.name}
          value={field.value}
          onChange={setFieldValue(form, field.name)}
          onBlur={field.onBlur}
        />
      </ControlField>
    )}
  </Field>
)
